import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { IconComponent } from 'src/app/components/icon/icon.component';
import { AppSettings } from 'src/app/config';
import { MaterialModule } from 'src/app/material.module';
import { AuthService } from 'src/app/services/auth.service';
import { CompanyService } from 'src/app/services/company.service';
import { CoreService } from 'src/app/services/core.service';
import { navItems } from '../sidebar/sidebar-data';
import { LanguageDropdownComponent } from 'src/app/components/language-dropdown/language-dropdown.component';
import { IconModule } from 'src/app/icon/icon.module';
import { DEFAULT_LANGUAGE } from 'src/app/shared/constants';
import { ThemeToggleComponent } from 'src/app/components/theme-toggle/theme-toggle.component';

interface notifications {
  id: number;
  img: string;
  title: string;
  subtitle: string;
}

interface profiledd {
  id: number;
  img: string;
  title: string;
  subtitle: string;
  link: string;
}

@Component({
  selector: 'app-header',
  imports: [RouterModule, CommonModule, NgScrollbarModule, IconModule, MaterialModule, IconComponent, LanguageDropdownComponent, TranslateModule, ThemeToggleComponent],
  templateUrl: './header.component.html',
  encapsulation: ViewEncapsulation.None
})
export class HeaderComponent {
  @Input() showToggle = true;
  @Input() toggleChecked = false;
  @Output() toggleMobileNav = new EventEmitter<void>();
  @Output() toggleMobileFilterNav = new EventEmitter<void>();
  @Output() toggleCollapsed = new EventEmitter<void>();

  showFiller = false;
  get user() {
    return this.authService.userInfo;
  }
  get company() {
    return this.companyService.companyInfo;
  }

  public selectedLanguage: any = {
    language: 'English',
    code: 'en',
    type: 'US',
    icon: '/assets/images/flag/icon-flag-en.svg'
  };

  public languages: any[] = [
    {
      language: 'English',
      code: 'en',
      type: 'US',
      icon: '/assets/images/flag/icon-flag-en.svg'
    },
    {
      language: 'Español',
      code: 'es',
      icon: '/assets/images/flag/icon-flag-es.svg'
    },
    {
      language: 'Français',
      code: 'fr',
      icon: '/assets/images/flag/icon-flag-fr.svg'
    },
    {
      language: 'German',
      code: 'de',
      icon: '/assets/images/flag/icon-flag-de.svg'
    }
  ];

  @Output() optionsChange = new EventEmitter<AppSettings>();

  constructor(
    private settings: CoreService,
    private authService: AuthService,
    private companyService: CompanyService,
    public dialog: MatDialog,
    private translate: TranslateService,
    private router: Router
  ) {
    translate.setDefaultLang(DEFAULT_LANGUAGE);
  }

  options = this.settings.getOptions();

  openDialog() {
    const dialogRef = this.dialog.open(AppSearchDialogComponent);

    dialogRef.afterClosed().subscribe(() => { });
  }

  private emitOptions() {
    this.optionsChange.emit(this.options);
  }

  onThemeChange(options: AppSettings) {
    this.options = options;
    this.emitOptions();
  }

  changeLanguage(lang: any): void {
    this.translate.use(lang.code);
    this.selectedLanguage = lang;
  }

  async logout() {
    await this.authService.logout();
  }

  notifications: notifications[] = [];

  profiledd: profiledd[] = this.user?.companyId ? [
    {
      id: 1,
      img: '/assets/images/svgs/icon-briefcase.svg',
      title: 'company',
      subtitle: 'company settings',
      link: `/company/${this.company?.id}`
    }
  ] : [];

  navigateToProfile() {
    this.router.navigate(['/profile']);
  }

  isActiveCompany() {
    return this.router.url.startsWith('/company');
  }
}

@Component({
  selector: 'main-search-dialog',
  imports: [RouterModule, MaterialModule, TablerIconsModule, FormsModule],
  templateUrl: 'search-dialog.component.html'
})
export class AppSearchDialogComponent {
  searchText = '';
  navItems = navItems;

  navItemsData = navItems.filter((navitem) => navitem.displayName);

  // filtered = this.navItemsData.find((obj) => {
  //   return obj.displayName == this.searchinput;
  // });
}
